export const GridOptionsSubTitle = [
    {
        text: "Bootstrap grid system allow all six breakpoints, and any breakpoints you can customize."
    }
];

export const VerticalAlignmentData = ["start", "center", "end"];


export const GridColumnSubTitle = [
    {
        text: 'You may use predefined grid classes. Using',
        code: ' .col-md-* '
    },
    {
        text: 'you can set the grid system.'
    }
];

export const VerticalAlignSubTitle = [
    {
        text: 'You can use the ',
        code: 'align-items-*'
    },
    {
        text: ' class to set the Vertical alignment.'
    }
];

export const HorizontalAlignSubTitle = [
    {
        text: 'You can use the ',
        code: 'justify-content-*'
    },
    {
        text: ' class to set the horizontal alignment.'
    }
];

export const NestingSubTitle = [
    {
        text: 'To nest your content with the default grid, add a new',
        code: '.row'
    },
    {
        text: ' and set of ',
        code: '.col-sm-*'
    },
    {
        text: ' columns within an existing ',
        code: '.col-sm-*'
    },
    {
        text: '  column.'
    }
];

export const OrderSubTitle = [
    {
        text: 'Using ',
        code: ' .order '
    },
    {
        text: 'class, you can set the order position.'
    }
];

export const OffsetSubTitle = [
    {
        text: 'You can offset the grid column using ',
        code: '.offset-*'
    },
    {
        text: ' grid class.'
    }
];

export const GridTableHeadData = [
    {
        text1: 'Extra small',
        text2: '<576px'
    },
    {
        text1: 'Small',
        text2: '≥576px'
    },
    {
        text1: 'Medium',
        text2: '≥768px'
    },
    {
        text1: 'Large',
        text2: '≥992px'
    },
    {
        text1: 'Extra large',
        text2: '≥1200px'
    },
    {
        class: 'digits',
        text1: 'Extra extra large',
        text2: '≥1400px'
    },
];

export const GridColumnData = [ 1,2,2,3,4,5,7,6,6,8,4,9,3,10,2,12]
    
export const GridOrderBodyData = [
    {
        xs: 3,
        order: '3',
        text: 'First Item (order-3)'
    },
    {
        xs: 5,
        order: 'first',
        text: 'Second Item (order-first)'
    },
    {
        xs: 4,
        order: 'last',
        text: 'Third Item (order-last)'
    },
    {
        xs: 3,
        order: '2',
        text: 'Fourth Item (order-2)'
    },
    {
        xs: 4,
        sm: 2,
        order: '5',
        text: 'fifth Item (order-5)'
    },
    {
        xs: 4,
        sm: 6,
        order: '4',
        text: 'sixth Item (order-4)'
    }
]

export const OffsetBodyData = [
    {
        xs: 4,
        sm: 5,
        class: 'offset-sm-3 offset-2',
        text: 'col-5 offset-3'
    },
    {
        xs: 4,
        sm: 2,
        class: 'offset-sm-2 offset-1',
        text: 'col-2 offset-2'
    },
    {
        xs: 5,
        sm: 4,
        class: 'offset-2',
        text: 'col-4 offset-2'
    },
    {
        xs: 4,
        sm: 3,
        class: 'offset-sm-2 offset-1',
        text: 'col-3 offset-2'
    }
]